import { Injectable, Injector } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import {LoginService} from "./login.service";
import { ToastService } from "./toast.service";
import { Router } from '@angular/router';

@Injectable()
export class LogoutOn401Interceptor implements HttpInterceptor {
    private loginService?: LoginService;

    constructor(
        private readonly injector: Injector,
        private readonly toastService: ToastService,
        private readonly router: Router
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError((e) => {
                if (e instanceof HttpErrorResponse) {
                    // Skip login request to avoid recursion
                    if (!e.url?.endsWith("api/v1/login")) {
                        if (e.status === 401 || e.status === 403) {
                            // Lazily get LoginService to avoid circular DI
                            if (!this.loginService) {
                                this.loginService = this.injector.get(LoginService);
                            }

                            this.loginService.logout();
                            this.toastService.add(
                                "Logged out",
                                "You were logged out - please log in again",
                                "warning"
                            );
                            this.router.navigate(["/login"]);
                        }
                    }
                }
                throw e;
            })
        );
        //return response.pipe(map(evt => {
        //  if (evt instanceof HttpResponse) {
        //    if (evt.status == 401 || evt.status == 403) {
        //      this.toastService.add("Logged out", "You were logged out - please log in again", "warning");
        //      this.loginService.logout();
        //    }
        //  }
        //  else {
        //    console.log("response", url, evt);
        //  }
        //    return evt;
        //}))
    }

}
